import { Instance } from 'mobx-state-tree';
import { RatingDtoModelBase } from './RatingDtoModel.base';

/* The TypeScript type of an instance of RatingDtoModel */
export interface RatingDtoModelType extends Instance<typeof RatingDtoModel.Type> {}

/* A graphql query fragment builders for RatingDtoModel */
export { selectFromRatingDto, ratingDtoModelPrimitives, RatingDtoModelSelector } from './RatingDtoModel.base';

/**
 * RatingDtoModel
 */
export const RatingDtoModel = RatingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
